import React from "react"

import { Avatar, Icon, Button, message } from "antd"

import DoubtsService from "services/students/doubts.service"
import globalStore from "store/index"

import "./Index.css"

export default class MiniPlayer extends React.Component {
  state = {
    isPlaying: false,
    selectedAudio: null,
  }

  componentDidMount() {}

  hasClass = (elem, className) => {
    return elem.classList.contains(className)
  }

  playAudio = (audio, e) => {
    // window.open(url, "_blank");

    // this.setState({ isPlaying: true });
    // const miniplayerThumbs = Array.from(
    //   document.getElementsByClassName("miniplayer-thumbnail")
    // );

    // miniplayerThumbs.forEach((e) => {
    //   e.classList.remove("playing");
    // });

    // if (e.target.tagName === "SPAN") {
    //   e.target.parentElement.classList.add("playing");
    // } else if (e.target.tagName === "svg") {
    //   e.target.parentElement.parentElement.classList.add("playing");
    // } else if (e.target.tagName === "path") {
    //   e.target.parentElement.parentElement.parentElement.classList.add(
    //     "playing"
    //   );
    // } else {
    //   e.target.classList.add("playing");
    // }

    this.setState({ selectedAudio: audio })
  }

  deleteItem = async ({ audio, doubtId }) => {
    const pageState = globalStore.ui.students.doubts.deleteAttachment
    await DoubtsService.deleteAttachment({
      pageState,
      doubtId,
      attachmentId: audio.attachment_id,
    })

    if (pageState.doubtErrors) {
      message.destroy()
      message.error("Failed to delete audio.")
      return
    }

    message.destroy()
    message.success("Audio deleted successfully.")

    globalStore.ui.students.doubts.show.doubt = pageState.doubt

    console.log("delete attachment:", pageState)
  }

  renderThumbnails = () => {
    const { selectedAudio } = this.state
    const { audios, deletable, doubtId } = this.props

    return (
      <div className="miniplayer-thumbnails">
        {audios.map((audio, i) => (
          <div className="deletable-item" key={i}>
            <div key={i} className="miniplayer-thumbnail" onClick={(e) => this.playAudio(audio, e)}>
              <Avatar
                style={{
                  backgroundColor: "#b9b9b9",
                }}
                shape="square"
                size={64}
              />
              <Icon type={selectedAudio && selectedAudio.url === audio.url ? "pause-circle" : "play-circle"} />
            </div>
            {deletable && (
              <div className="delete-icon" onClick={() => this.deleteItem({ audio, doubtId })}>
                <Icon type="delete" />
              </div>
            )}
          </div>
        ))}
      </div>
    )
  }

  render() {
    const { selectedAudio } = this.state
    const { audios } = this.props

    if (audios && audios.length === 0) return null

    return (
      <div className="miniplayer-wrapper">
        {this.renderThumbnails()}
        {selectedAudio && (
          <div className="audio-modal">
            <div className="audio-player">
              <audio controls autoplay="autoplay">
                <source src={selectedAudio.url} />
                Your browser does not support the audio element.
              </audio>
              <h3>{selectedAudio.file_name}</h3>
              <Button
                type="primary"
                shape="circle"
                icon="close"
                onClick={() => this.setState({ selectedAudio: null })}
              />
            </div>
          </div>
        )}
      </div>
    )
  }
}
